import { render, staticRenderFns } from "../templates/normal_fcont_202.html?vue&type=template&id=48400889&scoped=true&"
import script from "./normal_fcont_202.vue?vue&type=script&lang=js&"
export * from "./normal_fcont_202.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48400889",
  null
  
)

export default component.exports